import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import EventCardList from "./EventCardList";
import '../Styles/RetreatWeekSelection.scss';

// Same fetch-and-filter pattern RetreatWeekSelection uses, filtered to camp_type = 'Family Camp'
// instead of 'Retreat'.
function FamilyCampWeekSelection({ nextPage, setSelectedPage, setWeekSelection }) {

   const navigate = useNavigate();
   const [queriedEvents, setQueriedEvents] = useState([])

   const getEvents = async () => {
      try {
         const response = await fetch('/getevents', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ selectedEvents: ['Family Camp'] })
         })
         const campEvents = await response.json();
         setQueriedEvents(campEvents.data);
      } catch (error) {
         console.log(error)
      }
   }

   useEffect(() => {
      getEvents()
   }, []);

   return (
      <div className="retreatWeekSelectionContainer">
         <div className="retreatWeekSelectionContent">
            <div className="retreatWeekSelectionHeading">
               Select Your Family Camp
            </div>
            <div className="retreatWeekSelectionSubHeading">
               Choose from the available Family Camp weeks below.
            </div>
            <div className="eventCardList">
               <EventCardList
                  campEvents={queriedEvents}
                  nextPage={nextPage}
                  setWeekSelection={setWeekSelection}
                  setSelectedPage={setSelectedPage}
               />
            </div>
            <div className="retreatWeekSelectionButtonsContainer">
               <div className="retreatWeekSelectionPreviousButton">
                  <button onClick={() => navigate('/individualaccount')}>
                     Previous
                  </button>
               </div>
            </div>
         </div>
      </div>
   )
}

export default FamilyCampWeekSelection;
